<template>
  <div class="required login">
    <div class="logo-wrapper"></div>
    <el-card class="login-form-layout lg:w-1/3 md:w-1/2">
      <el-form :model="member"  ref="memberForm" :rules="loginRules" label-width="6.25rem" class="my-5 mx-6">
        <h2 class="login-title">创建账号</h2>
        <div class="flex justify-center mt-5 mb-8">
          <el-radio-group v-model="member.createAccountMethod" @change="createAccountMethodChange" size="medium" fill="#123B7F">
            <el-radio-button :label="1">通过手机号</el-radio-button>
            <el-radio-button :label="2">通过邮箱</el-radio-button>
          </el-radio-group>
        </div>

        <el-form-item label="用户名：" prop="username">
          <el-input v-model="member.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="设置密码：" prop="password">
          <el-input v-model="member.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="重复密码：" prop="repeatPassword">
          <el-input v-model="member.repeatPassword" type="password"  placeholder="请再次输入密码"></el-input>
        </el-form-item>

        <div v-if="member.createAccountMethod==1">
          <el-form-item label="手机号：" prop="phone" class="phoneInput">
            <el-input v-model="member.phone" type="text" placeholder="请输入您的手机号">
              <span slot="prefix">
                <span>(+86)</span>
              </span>
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="邮箱地址：" prop="email" >
            <el-input v-model="member.email" type="text" placeholder="请输入您的邮箱" ></el-input>
          </el-form-item>
        </div>
        <el-form-item label="验证码：" prop="verifyCode">
          <el-input v-model="member.verifyCode" type="text"  placeholder="请输入您的验证码">
                <span slot="suffix" >
                    <button type="button" @click="getVerifyCode" class="px-3 py-2 rounded verifyBtn" :class="[!canClick?'verifyBtn':'noActiveVerityBtn']" :disabled="canClick">
                      {{ content }}
                    </button>
                  </span>
          </el-input>
        </el-form-item>

        <el-form-item label-width="0">
          <el-button class="goBackBtn" style="width:47%;" @click="goBack" size="medium">
            返回登录
          </el-button>
          <el-button style="width:47%;margin-left:6%;background-color: #123B7F;color:#FFF;" @click="handleConfirm()" size="medium">
            创建账号
          </el-button>
        </el-form-item>
        <div class="text-sm agree">
          <el-checkbox v-model="checked" ></el-checkbox>
          <span class="pl-2">
                <span>我已阅读并接受</span>
                <a href="javascript:;" class="underline agreeTxt" @click="userAgreeClick()">用户协议</a>
                <span>和</span>
                <a href="javascript:;" class="underline agreeTxt" @click="secretAgreeClick()">隐私协议</a>
              </span>
        </div>
      </el-form>
    </el-card>

    <el-dialog class="myDialog" title="用户协议" :visible.sync="dialogUserAgreeVisible" width="80%" :center="true" top="5.5vh">
      <userAgree/>
    </el-dialog>
    <el-dialog class="myDialog" title="隐私政策" :visible.sync="dialogSecretAgreeVisible" width="80%" :center="true" top="5.5vh">
      <secretAgree/>
    </el-dialog>

  </div>

</template>

<script>
import secretAgree from "@/views/register/components/secretAgree";
import userAgree from "@/views/register/components/userAgree";
export default {
  name: "registerContent",
  data(){
    const validatePass = (rule, value, callback) => {
      if(value === null || value === ''){
        callback(new Error('请输入密码'))
      }else if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    };
    const checkedRepeatPass = (rule, value, callback)=>{
      if(value === null || value === ''){
        callback(new Error('请输入重复密码'))
      }if(value.length < 6){
        callback(new Error('密码不能小于6位'))
      }else if(this.member.password!=value){
        callback(new Error('两次输入密码不一致!'))
      }else {
        callback()
      }
    };

    const checkphone = (rule, value, callback) => {
      if (value === null || value === '') {
        callback(new Error("请输入手机号"));
      } else if (value.length!=11) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    const checkVerifyCode = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(new Error("请输入验证码"));
      } else if (value.length!=6) {
        callback(new Error("请输入正确的验证码!"));
      } else {
        callback();
      }
    };
    return {
      member:{
        username:"",
        nickName:"",
        email:"",
        phone:"",
        password:"",
        note:"",
        createAccountMethod:1,
        repeatPassword:"",
        verifyCode:""
      },
      checked:false,
      dialogUserAgreeVisible:false,
      dialogSecretAgreeVisible:false,
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, message: '长度大于3', trigger: 'blur' }
        ],
        password: [{required: true, trigger: 'blur', validator: validatePass}],
        repeatPassword: [{required: true, trigger: 'blur', validator: checkedRepeatPass}],
        phone:[{required: true, trigger: 'blur', validator: checkphone}],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur',validator: checkVerifyCode }
        ],
        email:[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      content: '获取验证码',
      totalTime: 60,
      canClick: false,
      clock:null
    }
  },
  components:{
    userAgree,
    secretAgree
  },
  methods:{
    handleConfirm() {
      if(!this.checked){
        this.$message('请先勾选用户协议和隐私协议！');
        return ;
      }

      this.$refs.memberForm.validate(valid => {
        if (valid) {
          var params = {
            username:this.member.username,
            email:this.member.email,
            phone:this.member.phone,
            password:this.member.password,
            createAccountMethod:1,
            verifyCode:this.member.verifyCode
          }
          // this.$confirm('是否要确认?', '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          //   createMember(this.member).then(response => {
          //     this.$message({
          //       message: '添加成功！',
          //       type: 'success',
          //       onClose:()=>{
          //         this.$router.push({path: '/login'})
          //       }
          //     });
          //   });
          // })
        } else {
          this.$message('参数验证不合法！');
          return false
        }
      })
    },
    //切换注册方式
    createAccountMethodChange(val){
      if(val==1){
        this.member.email="";
      }else{
        this.member.phone="";
      }
      this.$refs["memberForm"].resetFields();
      this.createAccountMethod = val;
      if(this.clock!=null){
          window.clearInterval(this.clock)
          this.content = '获取验证码'
          this.totalTime = 60
          this.canClick = false
      }
    },
    //返回登录页
    goBack(){
      this.$router.push({
        path: '/login'
      });
    },
    //用户协议
    userAgreeClick(){
      this.dialogUserAgreeVisible = true;
    },
    //隐私协议
    secretAgreeClick(){
      this.dialogSecretAgreeVisible = true;
    },
    //获取验证码
    getVerifyCode(){
      if (this.canClick){
        return
      }else{
        this.canClick = true
        this.content = this.totalTime + 's后重新获取'
        this.clock =  window.setInterval(() => {
          this.totalTime--
          this.content = this.totalTime + 's后重新获取'
          if (this.totalTime < 0) {
            window.clearInterval(this.clock)
            this.content = '获取验证码'
            this.totalTime = 60
            this.canClick = false
          }
        }, 1000)
      }
    }

  }
}
</script>

<style scoped>
.login {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/login_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.login-title {
  font-size: 1.875rem;
  font-weight: bold;
  color: #333333;
  letter-spacing: 2px;
  text-align: center;
}

/deep/ .el-radio-button__inner:hover{
  color: #123B7F;
}

/deep/ .el-input__inner {
  /*width: 220px;*/
  border-radius: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  padding-left:0 ;
  /*outline: medium;*/
}
/deep/ .el-button+.el-button {
   margin-left: 0px;
}
.goBackBtn{
  color: #123B7F;
  border-color: #123B7F;
}
.goBackBtn:hover{
  background-color: #123B7F;
  color: #FFFFFF;
}
.el-button--primary {
  color: #FFF;
  background-color: #123B7F;
  border-color: #123B7F;
}

/deep/ .el-button:hover {
  background: #123B7F;
  border-color: #123B7F;
  color: #FFF;
}

/deep/ .el-input__inner:focus{
  border-color: #123B7F;
}
/deep/ .el-textarea__inner:focus{
  border-color: #123B7F;
}

/*修改input placeholder字体大小*/
/deep/ input::-webkit-input-placeholder {
  font-size:0.875rem;

}
/deep/ input::-ms-input-placeholder {
  font-size:0.875rem;
}

.agree{
  letter-spacing: 2px;
}
.agreeTxt{
  color: #123B7F;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate
.el-checkbox__inner{
  background-color:#123B7F!important;
  border-color:#123B7F!important;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #123B7F!important;
}
/deep/ .el-checkbox.is-bordered.is-checked{
  border-color: #DCDFE6!important;
}
/deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color:  #DCDFE6!important;
}


/deep/.el-dialog__body {
  height: 80vh;overflow: auto;
}
.verifyBtn{
  background: #123B7F;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
.noActiveVerityBtn{
  background: #ccc;
  color:#fff;
  font-size: 14px;
  line-height: 20px;
}
/* 手机号输入框默认提示pl 设置 */
/deep/ .phoneInput .el-input--prefix .el-input__inner {
  padding-left: 46px;
}

.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  /*width: 28rem;*/
  margin: 140px auto;
}

/deep/ .myDialog .el-icon-close:hover{
  color: #123B7F;
}

</style>